<template>
  <div>
    <div class="line-charts" :class="{ 'is-single': visibleChartCount < 2 }">
      <div
        class="panel"
        v-show="canShowChart(name)"
        :key="index"
        v-for="(name, index) in chartNames"
      >
        <h2>{{ $t(`DASHBOARD_REACH_CHARTS_${name}`) }}</h2>
        <div class="m-chart">
          <div
            class="chart"
            :ref="`reach${name}`"
            style="width: 100%; height: 100%"
          ></div>
          <span class="chart-export"><i class="bi-download"></i>
            <ul class="export-list">
              <li @click="exportLineChart(name, 'svg')">SVG</li>
              <li @click="exportLineChart(name, 'csv')">CSV</li>
            </ul>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions, mapState } from "vuex";
import PageCharts from "@/models/page-charts";
import linesChart, { exportChart as exportLinesChart } from "@/models/charts/elines";
import { scheduleCharts } from "@/models/charts/echarts-touch";

export default {
  name: "Dash-activity-body",
  computed: {
    ...mapGetters([
      "getSelectedPages",
      "loadingStatus",
      "getAnalizedPages",
      "getUnionPagesData",
      "getSocialOfPageInAnalize",
    ]),
    locale() {
      return this.$locale.DASHBOARD.REACH_CHARTS;
    },
    // Получаем только админские страницы для отображения в Reach
    adminPages() {
      const { pages } = this.getUnionPagesData;
      return pages.filter(page => page.is_admin);
    },
    visibleChartCount() {
      return this.chartNames.filter((name) => this.canShowChart(name)).length;
    },
  },

  components: {},
  data() {
    return {
      chartNames: ["reach", "reach_subscribers", "mobile_reach"],
      loaded: false,
    };
  },
  methods: {
    canShowChart(name) {
      const socials = this.getSocialOfPageInAnalize;
      // Проверяем наличие админских страниц
      if (!this.adminPages || this.adminPages.length === 0) {
        return false;
      }
      
      if (name == "reach_subscribers" || name == "mobile_reach") {
        // Проверяем, что есть админские VK страницы
        const hasAdminVK = this.adminPages.some(page => page.social === "VK");
        return hasAdminVK;
      } else {
        return true;
      }
    },
    renderCharts() {
      const renderId = (this._renderId = (this._renderId || 0) + 1);
      if (this._stopCharts) this._stopCharts();
      this.charts.forEach((chart) => {
        if (chart && typeof chart.dispose === "function") chart.dispose();
      });
      this.charts = [];
      this.loaded = false;
      const { datesRangePosts } = this.getUnionPagesData;
      const colors = Object.entries(this.$colors).map(([key, value]) => {
        return { key, value };
      });
      const jobs = [];
      this.chartNames.forEach((name, index) => {
        const ref = this.$refs[`reach${name}`];
        const el = Array.isArray(ref) ? ref[0] : ref;
        if (!el) return;
        jobs.push({
          el,
          run: async () => {
            const chart = await linesChart({
              pages: this.adminPages,
              datesRange: datesRangePosts,
              datesRangePosts: datesRangePosts,
              name,
              ref: el,
              type: "reach",
              color: colors[index],
            });
            if (this._renderId !== renderId) {
              if (chart && typeof chart.dispose === "function") chart.dispose();
              return;
            }
            this.charts[index] = chart;
          },
        });
      });
      this._stopCharts = scheduleCharts(jobs, { batchSize: 3 });
    },
    getRefElement(refName) {
      if (this.$refs[refName]) {
        if (Array.isArray(this.$refs[refName])) {
          if (this.$refs[refName].length > 0) {
            return this.$refs[refName][0];
          }
        } else {
          return this.$refs[refName];
        }
      }
      return null;
    },
    async exportLineChart(name, type) {
      const chartIndex = this.chartNames.indexOf(name);
      
      if (chartIndex === -1 || !this.charts[chartIndex]) {
        return;
      }
      
      const chart = this.charts[chartIndex];
      const refKey = `reach${name}`;
      const chartElement = this.getRefElement(refKey);
      
      if (!chartElement) {
        return;
      }
      
      const { datesRangePosts } = this.getUnionPagesData;
      const colors = Object.entries(this.$colors).map(([key, value], idx) => {
        return { key, value };
      });
      
      try {
        await exportLinesChart({
          chart,
          container: chartElement,
          chartData: { ...this.getUnionPagesData, pages: this.adminPages }, // Используем только админские страницы
          datesRange: datesRangePosts,
          name,
          type: "reach",
          color: colors[chartIndex],
          exportType: type
        });
        
        this.renderCharts();
      } catch (error) {
        this.renderCharts();
      }
    },
  },
  created() {
    this.charts = [];
  },
  async mounted() {
    setTimeout(this.renderCharts, 0);
  },
  beforeDestroy() {
    if (this._stopCharts) this._stopCharts();
    this.charts.forEach((chart) => {
      if (chart && typeof chart.dispose === "function") chart.dispose();
    });
  },
};
</script>

<style></style>
